export const projects = {
  async novel() {
    const { exportDoc } = await import(/* webpackChunkName: "novelExports" */ './novel');
    return { exportDoc };
  },
};
